module.exports = __webpack_public_path__ + "static/media/33000150.eff90e8e.jpg";